<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <h2 class="large_label">入出金履歴</h2>
      <div>
        <select class="select_form" v-model="selectedCollection">
          <option value="transfers" selected>入金履歴</option>
          <option value="payouts">出金履歴</option>
        </select>
      </div>
      <template v-for="(log, index) in displayCollection">
        <TransferLogBox v-if="hasSelectedTransfer" :transfer-log="log" :key="index"/>
        <PayoutLogBox v-else :payout-log="log" :key="index"/>
      </template>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import sub_collection from "@/assets/js/functions/firebase/firestore/sub_collection";
  import TransferLogBox from "@/components/molecules/box/TransferLogBox";
  import PayoutLogBox from "@/components/molecules/box/PayoutLogBox";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";

  export default {
    name: "PayoutLogs",

    components: {TransferLogBox, PayoutLogBox},

    mixins: [sub_collection],

    data() {
      return {
        transfers: [],
        payouts: [],
        selectedCollection: 'transfers',
        displayCollection: []
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid'}),

      hasSelectedTransfer() {
        return this.selectedCollection === COLLECTION_NAMES.TRANSFERS
      }
    },

    watch: {
      selectedCollection: {
        handler: function () {
          this.displayCollection = this.hasSelectedTransfer ? this.transfers : this.payouts
        }
      },
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    async created() {
      await this.retrieve(COLLECTION_NAMES.TRANSFERS);
      await this.retrieve(COLLECTION_NAMES.PAYOUTS);
      this.displayCollection = this.transfers;
    },

    methods: {
      async retrieve(collectionName) {
        const query = this.subCollectionDocRef(
          COLLECTION_NAMES.OPERATOR_STRIPES,
          this.uid,
          collectionName
        ).where(
          "isDeleted", "==", false
        ).orderBy('createdAt', 'desc');
        await this.retrieveSubCollectionDocs(query).then(docs => {
          if (collectionName === COLLECTION_NAMES.TRANSFERS) {
            this.transfers = docs;
          } else {
            this.payouts = docs;
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background: linear-gradient(45deg, $client_third, $client_third, $operator_secondary, $operator_secondary);

    > .contents {
      @include index-contents();

      > div {
        display: flex;
        justify-content: flex-end;
        width: 100%;
      }

      > .payment-log_box {
        width: 100%;
      }
    }
  }
</style>